<template>
    <van-popup v-model="showPaymentPassword" position="bottom" style="height: 90%;">
        <div style="font-size: 18px; text-align: center; padding: 30px 0 10px 0;">设置支付密码</div>
        <div style="text-align: center; color: #888888; padding: 10px;">{{paymentPassword === '' ? '请设置支付密码，用于密码支付' : '请再次输入设置支付密码，用于确认支付密码'}}</div>
        <van-password-input :value="password" :focused="showPaymentPasswordKeyboard" @focus="showPaymentPasswordKeyboard = true" />
        <van-number-keyboard v-model="password" :show="showPaymentPasswordKeyboard" :maxlength="6" />
    </van-popup>
</template>

<script>
    import api from "../../assets/js/api";

    export default {
        name: "SetPaymentPasswordPopup",
        data(){
            return {
                password : '',
                showPaymentPasswordKeyboard : true,
                showPaymentPassword : false,
                paymentPassword : '',
                confirmPaymentPassword : '',
            };
        },
        watch : {
            password(newValue, oldValue){
                if(newValue.length >= 6){
                    if(this.paymentPassword === ''){
                        this.paymentPassword = newValue;
                        this.password = '';
                    }else if(this.paymentPassword !== '' && this.confirmPaymentPassword === ''){
                        this.confirmPaymentPassword = newValue;
                        if(this.paymentPassword !== this.confirmPaymentPassword){
                            this.password = this.paymentPassword = this.confirmPaymentPassword = '';
                            this.$notify({ type: 'danger', message: '两次输入的支付密码不一致，请重新输入' });
                        }else{
                            let self = this;
                            api.request('/user/set_payment_password', {
                                payment_password : this.paymentPassword,
                                confirm_payment_password : this.confirmPaymentPassword,
                            }).then(res => {
                                self.$notify({ type: 'success', message: res.msg });
                                self.password = self.paymentPassword = self.confirmPaymentPassword = '';
                                self.close();
                            }).catch(res => {
                                self.$notify({ type: 'danger', message: res.msg });
                                self.password = self.paymentPassword = self.confirmPaymentPassword = '';
                            });
                        }
                    }
                }
            }
        },
        methods : {
            open(){
                this.showPaymentPassword = true;
            },
            close(){
                this.showPaymentPassword = false;
            },
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/beilin/SetPaymentPasswordPopup.vue